import React from 'react'
import { Form } from 'react-bootstrap';


export type CheckboxSwitchProps = {
    name: string,
    checked: boolean,
    label?: string,
    disabled?: boolean,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    [key: string]: any
}


export const CheckboxSwitch = (props : CheckboxSwitchProps) => (
        <div className={`tp-checkbox ${props?.checked ? "tp-checkbox-checked" : "tp-checkbox-unchecked"}`}>
            <Form.Check
                type='switch'
                autoComplete='off'
                {...props}
            />
        </div>
)

export default CheckboxSwitch;
